import React, { useState, useEffect, useMemo } from 'react';
import { FormGroup, Input, Label, Button, Col, Row } from 'reactstrap';
import './PortActivation.css';
import { connect } from 'react-redux';
import CompanyAutocomplete from './CompanyAutocomplete';
import LocationDetails from './LocationDetails';
import OptionalDropdownSelect from './OptionalDropdownSelect';
import { getGroupsFilterCompanies } from '../actions/Reports';

const lineTypeList = [
  { name: 'Alarm', value: 'alarm' },
  { name: 'Fire Alarm', value: 'fireAlarm' },
  { name: 'Secure Entry', value: 'secureEntry' },
  { name: 'Elevator', value: 'elevator' },
  { name: 'Fax', value: 'fax' },
  { name: 'Modem', value: 'modem' },
  { name: 'Voice', value: 'voice' },
  { name: 'Hunt', value: 'hunt' },
  { name: 'OOBM', value: 'oob' },
  { name: 'Page', value: 'page' },
  { name: 'PRI', value: 'pri' },
  { name: 'Ring Down', value: 'ringDown' },
];
const PortActivationBody = ({
  companies,
  locations,
  selectedCompany,
  selectedDates,
  selectAlarmProtocol,
  alarmProtocolValue,
  disabledButton,
  locationId,
  summaryStatus,
  downloadType,
  selectedReport,
  includeSummary,
  alarmProtocol,
  user,
  companyGroups,
  getGroupsFilterCompanies,
  companyGroupFilteredList,
  reportSymbol,
  selectedLineTypes,
  setIntegrationValue
}) => {
  const [locationStatus, setLocationStatus] = useState(false);
  const [companiesList, setCompaniesList] = useState(companies.docs || []);
  const [summary, setSummary] = useState(false);
  const [type, setType] = useState(false);
  const token = localStorage.getItem('jwtToken');
  const [dateRange, setDateRange] = useState({
    fromDate: '',
    toDate: '',
  });
  const [clearList, setClearList] = useState(false);
  const [integration, setIntegration] = useState("all");

  useEffect(() => {
    setIntegrationValue(integration);
  }, [integration]);

  useEffect(() => {
    if (selectedReport) {
      if (dateRange.fromDate.length > 0 && dateRange.toDate.length > 0 && type) {
        disabledButton(false);
      }
      if (reportSymbol === 'BOL' && type && dateRange.fromDate.length > 0) { // Date range is optional for Unregistered Edge Devices
        disabledButton(false);
      }
    } else {
      type ? disabledButton(false) : locationStatus && disabledButton(false);
    }
    selectedDates(dateRange);
    if (alarmProtocol) {
      if (!alarmProtocolValue.length) {
        disabledButton(true);
      } else {
        disabledButton(false);
      }
    }
  }, [locationStatus, dateRange, type, alarmProtocolValue]);
  const onCompanyGroupFilter = async item => {
    if (item.suggestion !== null) {
      const result = await getGroupsFilterCompanies(token, item.suggestion.groupId);
      setCompaniesList(result.managedCompanies);
      selectedCompany(result.managedCompanies);
    }
    setClearList(!clearList);
  };
  const selectedCompanies = list => {
    selectedCompany(list);
  };
  const onDateChange = e => {
    setDateRange({ ...dateRange, [e.currentTarget.name]: e.currentTarget.value });
  };
  const onSummaryChange = value => {
    if (summary) {
      summaryStatus('no');
    } else {
      summaryStatus('yes');
    }
    setSummary(!summary);
  };
  const onLineTypeSelect = e => {
    const lineType = e.map(item => item.value);
    selectedLineTypes(lineType);
  };
  useEffect(() => {
    if (reportSymbol === 'LT') {
      const allLineTypes = lineTypeList.map(item => item.value);
      selectedLineTypes(allLineTypes);
    }
  }, []);
  return (
    <>
      <Row style={{ display: 'flex', flexDirection: 'row' }}>
        <Col md={6}>
          <>
            {user.role === 'superAdmin' && (
              <>
                <h1>Company Group</h1>
                <OptionalDropdownSelect
                  isDisabled={!(companyGroups.length > 0)}
                  nameTag="companyGroup"
                  filterTag="groupName"
                  className="testing-filter"
                  placeholder={
                    !(companyGroups.length > 0) ? 'No Company Group Found' : 'Select Company Group'
                  }
                  dropdownList={companyGroups}
                  onChange={onCompanyGroupFilter}
                />
              </>
            )}
            <h1>Company</h1>
            <>
              <OptionalDropdownSelect
                isDisabled={!(companiesList.length > 0)}
                MultiSelect
                nameTag="company"
                filterTag="name"
                className="testing-filter"
                placeholder={
                  !(companyGroups.length > 0)
                    ? user.role === 'admin' || user.role === 'enterpriseAdmin'
                      ? user.company.name
                      : 'No Company Found'
                    : user.role === 'superAdmin'
                    ? 'All Companies'
                    : 'Select Company'
                }
                dropdownList={companiesList}
                onChange={selectedCompanies}
                clearList={clearList}
              />
            </>
            {reportSymbol === 'LT' && (
              <>
                <h1>Line Type</h1>
                <OptionalDropdownSelect
                  MultiSelect
                  nameTag="name"
                  filterTag="name"
                  className="testing-filter"
                  placeholder="Select Line Type"
                  dropdownList={lineTypeList}
                  showFirstListElement
                  onChange={onLineTypeSelect}
                />
              </>
            )}
          </>
        </Col>
        <Col md={6}>
          <div>
            {!alarmProtocol && selectedReport && (
              <>
                <h1>
                  {reportSymbol === 'BOL' ? "Date" : "Date Range"}
                </h1>
                <Row>
                  
                  <Col md={5}>
                    <Input
                      placeholder="Please specify"
                      required
                      type="date"
                      name="fromDate"
                      value={dateRange.fromDate}
                      onChange={onDateChange}
                    />
                  </Col>
                 
                  <Col md={1}>
                    {reportSymbol !== 'BOL' && <p style={{ marginTop: '5px' }}>To</p>}
                  </Col>
                  {reportSymbol !== 'BOL' && (
                    <Col md={5}>
                      <Input
                        placeholder="Please specify"
                        required
                        type="date"
                        name="toDate"
                        value={dateRange.toDate}
                        onChange={onDateChange}
                      />
                    </Col>
                  )}
                </Row>
              </>
            )}

            {alarmProtocol && (
              <>
                <h1>Alarm Protocol Relay Enabled</h1>
                <Input
                  type="select"
                  className="testing-filter"
                  name="aprReporting"
                  value={alarmProtocolValue}
                  onChange={e => {
                    selectAlarmProtocol(e?.currentTarget.value);
                  }}
                >
                  {!alarmProtocolValue.length && <option value="">Select value</option>}
                  <option key="True" value="true">
                    True
                  </option>
                  <option key="False" value="false">
                    False
                  </option>
                </Input>
              </>
            )}
            {reportSymbol === 'EDI' && (
              <div className='integration-report'>
                <h1>Select Integration Type</h1>
                <Row>
                  <Col sm={4}>
                    <select
                      className="form-control"
                      name="select-chart"
                      value={integration}
                      onChange={(e) => { setIntegration(e.target.value) }}
                    >
                      {['All', 'Integrated', 'Not Integrated'].map(item => (
                        <option key={item?.replace(/\s+/g, '-').toLowerCase()} className="chart-options" id={`test-${item?.replace(/\s+/g, '-').toLowerCase()}`} value={item?.toLowerCase()}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </Col>
                </Row>
              </div>
            )}
            <h1>Export Format</h1>
            <Row>
              <Col sm={3}>
                <Label check sm={6}>
                  <Input
                    type="radio"
                    name="exportType"
                    onChange={() => {
                      downloadType('csv');
                      setType(true);
                    }}
                  />
                  CSV
                </Label>
              </Col>
              <Col sm={3}>
                <Label check sm={6}>
                  <Input
                    type="radio"
                    name="exportType"
                    onChange={() => {
                      downloadType('pdf');
                      setType(true);
                    }}
                  />
                  PDF
                </Label>
              </Col>
            </Row>
            {includeSummary && (
              <FormGroup
                style={{
                  marginRight: '20px',
                  marginTop: '20px',
                  display: 'flex',
                  alignItems: 'flex-end',
                }}
              >
                <Label check>
                  <Input type="checkbox" checked={summary} onChange={onSummaryChange} />
                  Include Summary Report
                </Label>
              </FormGroup>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};
const mapStateToProps = state => {
  return {
    user: state.AppState.user,
    boxes: state.AppState.boxes,
    companies: state.AppState.companies,
    companyGroupFilteredList: state.AppState.groupFilteredCompanies,
  };
};
const mapDispatchToProps = dispatch => ({
  getGroupsFilterCompanies: (token, gid) => dispatch(getGroupsFilterCompanies(token, gid)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PortActivationBody);
